import angular from 'angular';

angular
  .module('cloudX')
  .controller('DeleteTaskPeriodicityLineDialogCtrl', [
    '$scope',
    'appMessages',
    'close',
    'relations',
    deleteTaskPeriodicityLineDialogCtrl,
  ]);

function deleteTaskPeriodicityLineDialogCtrl($scope, appMessages, close, relations) {
  $scope.relations = relations;
  $scope.close = function(result) {
    close(result, 500);
    //$element.modal('hide');
  };
  $scope.cancel = function() {
    //$element.modal('hide');
    close(null, 500);
  };
}
